import { Company } from '@shared-ikp/model/company.model';
import { UmmeldungResponse } from '../../../../generated/model/ummeldung-response.model';
import { Ummeldung } from '../../../../generated/model/ummeldung.model';
import { MeterPoint } from '../../../model/meter-point.model';
import { UmmeldungWizardData } from '../models';
import { VertragspartnerMode } from '../schemas';
import { buildBisherigerKunde, resolveBisherigerVertragspartnerMode } from './bisheriger-vertragspartner.mapper';
import { mapToProduktdaten } from './produktdaten.mapper';

export interface UmmeldungWizardDataInput {
  zaehlpunkt: MeterPoint;
  loadedUmmeldung: UmmeldungResponse | null;
  /** Draft restored from session storage after a reload; newer than the backend copy, so it wins. */
  restoredDraft: Ummeldung | null;
  zaehlpunktUnternehmen: Company | null;
  accountUnternehmen: Company[];
  verwalteteUnternehmen: Company[];
  uploadMode: boolean;
}

export function buildUmmeldungWizardData(input: UmmeldungWizardDataInput): UmmeldungWizardData {
  const { zaehlpunkt, loadedUmmeldung, restoredDraft, zaehlpunktUnternehmen, accountUnternehmen, verwalteteUnternehmen, uploadMode } =
    input;

  const activeUmmeldung = restoredDraft ?? loadedUmmeldung?.ummeldung ?? { produktdaten: [mapToProduktdaten(zaehlpunkt)] };

  return {
    activeUmmeldung: withBisherigerKunde(activeUmmeldung, zaehlpunkt, zaehlpunktUnternehmen),
    metadata: loadedUmmeldung?.ummeldungMetadata ?? null,
    aktuellerZaehlpunkt: zaehlpunkt,
    zaehlpunktUnternehmen,
    accountUnternehmen,
    verwalteteUnternehmen,
    uploadMode,
  };
}

function withBisherigerKunde(ummeldung: Ummeldung, zaehlpunkt: MeterPoint, vertragspartnerUnternehmen: Company | null): Ummeldung {
  const mode = resolveBisherigerVertragspartnerMode(zaehlpunkt);
  if (mode === VertragspartnerMode.BEARBEITBAR || !vertragspartnerUnternehmen) {
    return ummeldung;
  }

  return {
    ...ummeldung,
    bisherigerKunde: buildBisherigerKunde({
      mode,
      zaehlpunkt,
      vertragspartnerUnternehmen,
      bisherigerKunde: ummeldung.bisherigerKunde,
    }),
  };
}
